import { deepCopy } from "@firebase/util";
import moment from "moment";
import { eventName as event, pageSection as PAGE_SECTION_VARIABLES } from "../constants/events/eventName";
import { DEFAULT_CURRENCY_CODE, FLOW_TYPE, PRODUCT_CLASSES_NAME, WHEELCHAIR_SSRCODE } from "../constants/variables";
import { bookingIniatedFrom, bookingType } from "../store/slices/booking";
import {
  GA4Implementation,
  getFlightNameWithProductClassType as getFlightNameWithProductClassTypeGA4,
  getGenderCount,
  pageSection as pageSectionConstants,
  getPageSection
} from "./GA4Implementation";
import { adhosType } from "./addons/addons";
import { EventType, loggingUserActivities } from "./loggingUserActivities/loggingUserActivities";
import { passengerCountFromCurrentBooking } from "./passengers";

const DATE_FORMAT = "YYYY-MM-DD HH:MM:SS";
const ONLY_DATE_FORMAT = "YYYY-MM-DD";
const LOGIN_USER = "Logged-in";
const GUEST_USER = "GUEST";

export const moEngagePush = (eventName, attributes) => {
  window.Moengage.track_event(eventName, attributes);
};

export function convertPriceToNumber(price) {
  try {
    if (price) {
      return parseFloat(price.split(",").join("").split("₹").join(""));
    }
    return "";
  } catch (error) {
    console.warn(error);
    return "";
  }
}

export function getNSegmentName(journey, n) {
  try {
    if (journey && journey.length > 0) {
      const flightName =
        journey[n]?.segments[0]?.identifier?.carrierCode + journey[n]?.segments[0]?.identifier?.identifier;
      return flightName;
    }
  } catch (error) {
    console.warn(error);
  }
}

export function getJourneyType(journey) {
  try {
    return journey.length === 1 ? "ONE_WAY" : "RETURN_TRIP";
  } catch (error) {
    console.warn(error);
  }
}

export function getPlanNameforSelectedFlight(details) {
  try {
    let planName = "";
    if (details?.brandFareIndex[details?.flightIndex] === 0) {
      planName = "Saver";
    } else {
      planName = "Flexi";
    }

    return planName;
  } catch (error) {
    console.warn(error);
  }
}
export function getPlanNameforSelectedFlightViaJourneyInd(details, flightInd) {
  try {
    let planName = "";
    if (flightInd === 0) {
      planName = "Saver";
    } else {
      planName = "Flexi";
    }

    return planName;
  } catch (error) {
    console.warn(error);
  }
}
export function getFlightNameWithProductClassType(journey, ind) {
  try {
    let productClassName = "";
    let textToReturn = "";
    const currentJourney = journey[ind];
    if (currentJourney && currentJourney.segments && currentJourney.segments.length > 0) {
      productClassName = currentJourney.segments[0]?.fares[0]?.productClass;
    }

    if (productClassName === "EC") {
      textToReturn += "Akasa Standard";
    } else {
      textToReturn += "Akasa Value";
    }
    return textToReturn;
  } catch (error) {
    console.warn(error);
  }
}
export function getSpecialyAbilityDetails(passengerSegments) {
  try {
    const response = {
      isWheelchair: false,
      count: 0
    };
    const paxInfo = passengerSegments[0]?.segments[0]?.passengerSegment;

    for (let ind = 0; ind < paxInfo.length; ind++) {
      const currentPaxSsr = paxInfo[ind]?.value?.ssrs;
      if (
        currentPaxSsr.filter((ssr) => {
          if (ssr.ssrCode === WHEELCHAIR_SSRCODE || ssr.ssrCode === "WCHC" || ssr.ssrCode === "WCHS") return ssr;
        }).length > 0
      ) {
        (response.isWheelchair = true), (response.count += 1);
      }
    }
    return response;
  } catch (error) {
    console.warn(error);
  }
}

export function getAllSeatsNumberOfPax(passengerSegments) {
  try {
    const response = {
      seatsNos: "",
      count: 0
    };
    for (let index = 0; index < passengerSegments.length; index++) {
      const element = passengerSegments[index];
      const paxInfo = element?.segments[0]?.passengerSegment;

      for (let ind = 0; ind < paxInfo.length; ind++) {
        const currentPaxSeats = paxInfo[ind]?.seats;
        if (currentPaxSeats.length > 0 && currentPaxSeats[0]) {
          response.seatsNos += `${currentPaxSeats[0]?.unitDesignator}, `;
          response.count += 1;
        }
      }
    }

    return response;
  } catch (error) {
    console.warn(error);
  }
}

export function getSumOfTax(taxObject) {
  try {
    let sum = 0;
    for (const property in taxObject) {
      sum += taxObject[property]?.amount;
    }
    return sum;
  } catch (error) {}
}
export function getPromoCodeFromBookingInState(currentBookingInState) {
  try {
    const promoCode = "";
    if (currentBookingInState?.typeOfSale?.promotionCode) {
      return currentBookingInState?.typeOfSale?.promotionCode;
    }
    return promoCode;
  } catch (error) {
    console.warn(error);
    return "";
  }
}

export function flightDetails(
  bookingInState,
  pageSectionAsParameter = PAGE_SECTION_VARIABLES.NEW_BOOKING,
  bookingInRedux = null,
  details
) {
  let flightNumbers = "";
  if (pageSectionAsParameter === "") {
    pageSectionAsParameter = PAGE_SECTION_VARIABLES.NEW_BOOKING;
  }

  if (bookingInRedux && bookingInRedux?.bookingIniatedFrom) {
    if (bookingInRedux?.bookingIniatedFrom == bookingIniatedFrom.MANAGE_BOOKING) {
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
    } else if (bookingInRedux?.bookingIniatedFrom == bookingIniatedFrom.CHECKIN_BOOKING) {
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    } else if (bookingInRedux?.bookingIniatedFrom == bookingIniatedFrom.NEW_BOOKING) {
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.NEW_BOOKING;
    }
  }
  if (bookingInRedux && bookingInRedux?.bookingType) {
    if (bookingInRedux?.bookingType == bookingType.CHANGE_BOOKING) {
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
    }
  }
  const departureCity = bookingInState?.journeys[0]?.designator?.origin;
  const arrivalCity = bookingInState?.journeys[0]?.designator?.destination;
  const flight_type = getFlightNameWithProductClassTypeGA4(bookingInState?.journeys);
  const depart_date = moment(bookingInState?.journeys[0]?.designator?.departure).format(ONLY_DATE_FORMAT);
  const return_date = moment(bookingInState?.journeys[0]?.designator?.arrival).format(ONLY_DATE_FORMAT) || null;
  const genderCount = getGenderCount(bookingInState);
  const passenger = passengerCountFromCurrentBooking(bookingInState?.passengers);
  const pnr = bookingInState?.recordLocator;
  let flight = "";
  let flightStops = "";
  // flight Number :
  for (let index = 0; index < bookingInState?.journeys.length; index++) {
    const currentJourney = bookingInState.journeys[index];
    flight = currentJourney.flightType;
    flightStops = currentJourney.stops;
    currentJourney.segments;
    for (let segInd = 0; segInd < currentJourney.segments.length; segInd++) {
      const segmentInfo = currentJourney.segments[segInd];
      flightNumbers += `${segmentInfo?.identifier?.carrierCode}-${segmentInfo?.identifier?.identifier}`;
      flightNumbers += ", ";
    }
  }
  const promoCode = getPromoCodeFromBookingInState(bookingInState);
  const pageSection = pageSectionAsParameter;

  return {
    flight_number: flightNumbers,
    depart_date,
    arrival_date: return_date,
    layover_airport_destination: "",
    currency: details?.selectedCurrency,
    seats_available: 3, // currently hard-codin,
    tag: "",
    search_passenger_count: passenger?.total,
    tags: "",
    noOfAdults: passenger?.adult,
    noOfChildren: passenger?.child,
    noOfInfants: passenger?.infant,
    seniorCitizen: passenger?.seniorcitizen,
    totalPassengers: passenger?.total,
    departureCity,
    male: genderCount.male,
    female: genderCount.female,
    arrivalCity,
    pnr,
    flightType: flight_type,
    flightStop: flightStops,
    flight,
    promoCode,
    pageSection
  };
}


export function subtractTimeFromDate(dateString) {
  const date = new Date(dateString);
  date.setHours(date.getHours() - 5);
  date.setMinutes(date.getMinutes() - 30);
  return new Date(date);
}

export function restructureObj(eventName, details) {
  const eventArray = {};

  if (eventName === event.CHECKIN_FAILED) {
    eventArray.pnr = details.pnr;
    eventArray.lastName = details.lastName;
    eventArray.source = details.source;
    eventArray.reason = details?.paymentAPIResponse || null;
    eventArray.orderId = details?.orderId || null;
  }

  if (eventName === event.FLEXI_BANNER) {
    eventArray.clickType = details.clickType;
  }

  if (eventName === event.PROMO_NUDGE_CLICKED) {
    eventArray.clickType = details.nudgeType;
  }

  if (window) {
    eventArray.pageurl = window.location.pathname;
  }

  if (eventName === event.FLIGHT_LISTING) {
    if (eventArray.pageurl === "/flight-search") {
      if (eventArray.pageurl !== "/flight-search") {
        eventArray.event = event.FLIGHT_SEARCH_MODIFY;
      } else {
        eventArray.event = event.FLIGHT_SEARCH;
      }
      if (
        details?.eventTrackStack?.eventStack?.origin &&
        details?.eventTrackStack?.eventStack?.origin === "MODIFY_SEARCH"
      ) {
        eventArray.event = event.FLIGHT_SEARCH_MODIFY;
      }
      eventArray.departureCity = details?.origin;
      eventArray.arrivalCity = details?.destination;
      eventArray.flight_type = details?.tripType;
      eventArray.depart_date = subtractTimeFromDate(details?.departureDateInState);
      eventArray.return_date =
        details?.tripType === "ONE_WAY" ? "" : subtractTimeFromDate(details?.arrivalDateInState);
      eventArray.special_fare = details?.specialFare?.name;
      eventArray.noOfAdults = details?.passenger?.adult;
      eventArray.noOfChildren = details?.passenger?.child;
      eventArray.noOfInfants = details?.passenger?.infant;
      eventArray.seniorCitizen = details?.passenger?.seniorcitizen;
      eventArray.totalPassengers = details?.passenger?.total;
      eventArray.total_number_of_flights_search_results = details?.response[0]?.length;
      eventArray.promoCode = details?.promoCode;

      let pageSectionInfo = PAGE_SECTION_VARIABLES.NEW_BOOKING;
      if (details?.currentBookingV2) {
        if (details?.currentBookingV2?.bookingIniatedFrom === bookingIniatedFrom.MANAGE_BOOKING) {
          pageSectionInfo = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
        }
      }
      eventArray.FlightDetail = {
        depart_date: moment(details?.departureDateInState).format(ONLY_DATE_FORMAT),
        arrival_date:
          details?.tripType === "ONE_WAY" ? "" : moment(details?.arrivalDateInState).format(ONLY_DATE_FORMAT),
        layover_airport_destination: "",
        currency: details?.selectedCurrency,
        seats_available: 3, // currently hard-codin,
        tag: "",
        search_passenger_count: details?.passenger?.total,
        tags: "",
        noOfAdults: details?.passenger?.adult,
        noOfChildren: details?.passenger?.child,
        noOfInfants: details?.passenger?.infant,
        seniorCitizen: details?.passenger?.seniorcitizen,
        totalPassengers: details?.passenger?.total,
        departureCity: details?.origin,
        arrivalCity: details?.destination,
        pageSection: pageSectionInfo
      };
    }
  }
  if (eventName === event.FLIGHT_SELECT) {
    eventArray.event = event.FLIGHT_SELECT;
    eventArray.flight_name = details?.flightDetails?.flightNumbers.toString();

    eventArray.depart_date = subtractTimeFromDate(details?.flightDetails.departureDateAndTime)
    eventArray.arrival_date = subtractTimeFromDate(details?.flightDetails.arrivalDateAndTime)
    eventArray.layover_airport_destination = details?.flightDetails?.Noofstops.toString();
    eventArray.total_price = getPlanNameforSelectedFlight(details) === "Flexi" ? details?.flightDetails?.totalFares[1]?.fareTotal : details?.flightDetails?.totalFares[0]?.fareTotal;
    eventArray.price_without_convenience_fee =  getPlanNameforSelectedFlight(details) === "Flexi" ? details?.flightDetails?.totalFares[1]?.fareTotal - 350 : details?.flightDetails?.totalFares[0]?.fareTotal - 350;
    eventArray.currency = details?.selectedCurrency;
    eventArray["Seats available"] = 3; // currently hard-coding
    eventArray.tag = "";
    eventArray.search_passenger_count = details?.passenger?.total;
    eventArray.plan_name = details.brandFareIndex[details?.flightDetails?.journeyIndexKey] === 0 ? "Saver" : "Flexi";
 
    eventArray.promoCode = details?.promocode;
    eventArray.flight_number = details?.flightDetails?.flightNumbers ? details?.flightDetails?.flightNumbers[0] : "";
    eventArray.seats_available= 3; // currently hard-codin;
    eventArray.flight_duration = details?.flightDetails?.duration;
    eventArray.noOfAdults = details?.passenger?.adult;
    eventArray.noOfChildren = details?.passenger?.child;
    eventArray.noOfInfants = details?.passenger?.infant;
    eventArray.seniorCitizen = details?.passenger?.seniorcitizen;
    eventArray.totalPassengers = details?.passenger?.total;

    eventArray.departureCity = details?.flightDetails?.originStation;
    eventArray.arrivalCity = details?.flightDetails?.destinationStation;

    eventArray.jouyney_type = details?.tripType;

    eventArray.arrival_terminal = details?.flightDetails?.arrivalTerminal;
    eventArray.departure_terminal = details?.flightDetails?.departureTerminal;
    eventArray.no_of_layover = details?.flightDetails?.Noofstops.length;
    eventArray.specialfares = details?.selectedSpecialFare?.name;

    eventArray.FlightDetail = {
      flight_number: details?.flightDetails?.flightNumbers ? details?.flightDetails?.flightNumbers[0] : "",
      depart_date: moment(details?.departureDate).format(ONLY_DATE_FORMAT),
      arrival_date: moment(details?.arrivalDate).format(ONLY_DATE_FORMAT),
      layover_airport_destination: "",
      layover_duration: details?.flightDetails?.duration,
      total_price: convertPriceToNumber(details?.flightDetails?.displayFare?.totalDisplayFare),
      currency: details?.selectedCurrency,
      seats_available: 3, // currently hard-codin,
      tag: "",
      flight_duration: details?.duration,
      search_passenger_count: details?.passenger?.total,
      tags: "",
      noOfAdults: details?.passenger?.adult,
      noOfChildren: details?.passenger?.child,
      noOfInfants: details?.passenger?.infant,
      seniorCitizen: details?.passenger?.seniorcitizen,
      totalPassengers: details?.passenger?.total,
      departureCity: details?.flightDetails?.originStation,
      arrivalCity: details?.flightDetails?.destinationStation,
      pageSection: getPageSection(details)
    };
  }
  if (eventName === event.BOOKING_INITIATED) {
    eventArray.event = event.BOOKING_INITIATED;
    eventArray.journey_type = details?.tripType;
    eventArray.SpecialFaresCategory = details?.specialFare?.name;
    eventArray.promoCode = details?.promoCode;
    eventArray.currency = details?.selectedCurrency;
    eventArray.departure_terminal = details?.journeyWatcher[0]?.departureTerminal;
    eventArray.return_terminal = details?.journeyWatcher[1]?.departureTerminal;
    eventArray.departureLocation = details?.journeyWatcher[0]?.originStation
    eventArray.returnLocation = details?.journeyWatcher[1]?.originStation
    eventArray.Adults = details?.passenger?.adult;
    eventArray.Children = details?.passenger?.child;
    eventArray.Infants = details?.passenger?.infant;
    eventArray.SeniorCitizens = details?.passenger?.seniorcitizen;
    eventArray.totalPassengers = details?.passenger?.total;

    // eventArray.option_selected = getPlanNameforSelectedFlightViaJourneyInd(details, 0);
    eventArray.flight_name = details?.journeyWatcher[0]?.flightNumbers[0];

    eventArray.depart_date = subtractTimeFromDate(details?.journeyWatcher[0]?.departureDateAndTime);
    eventArray.arrival_date = subtractTimeFromDate(details?.journeyWatcher[0]?.arrivalDateAndTime)

    eventArray.to_fare_amount = convertPriceToNumber(details?.journeyWatcher[0]?.displayFare?.totalDisplayFare) - 350;
    eventArray.return_fare_amount = details?.journeyWatcher.length > 1 ? convertPriceToNumber(details?.journeyWatcher[1]?.displayFare?.totalDisplayFare) - 350 : null;

    eventArray.Passenger_count = details?.passenger?.total;
    eventArray.total_price = details?.breakdown?.authorizedBalanceDue;

    eventArray.plan_name  = getPlanNameforSelectedFlightViaJourneyInd(details, details?.brandType === PRODUCT_CLASSES_NAME.EC ? 0 : 1 );
    eventArray.return_plan_name =
      details?.tripType === "ROUND_TRIP" ? getPlanNameforSelectedFlightViaJourneyInd(details, 1) : "";

    eventArray.return_flight_name = details?.journeyWatcher[1]?.flightNumbers.toString();

    eventArray.return_depart_date = details?.journeyWatcher.length > 1 ? subtractTimeFromDate(details?.journeyWatcher[1]?.departureDateAndTime) : null; 
    eventArray.return_arrival_date = details?.journeyWatcher.length > 1 ? subtractTimeFromDate(details?.journeyWatcher[1]?.arrivalDateAndTime) : null;
   
    eventArray.currency = details?.selectedCurrency;
    eventArray.Passenger_count = details?.passenger?.total;
    eventArray.FlightDetail = {
      depart_date: moment(details?.journeyWatcher[0]?.departureDateAndTime).format(ONLY_DATE_FORMAT),
      arrival_date: moment(details?.journeyWatcher[0]?.arrivalDateAndTime).format(ONLY_DATE_FORMAT),
      layover_airport_destination: "",
      currency: details?.selectedCurrency,
      seats_available: 3, // currently hard-codin,
      tag: "",
      search_passenger_count: details?.passenger?.total,
      tags: "",
      noOfAdults: details?.passenger?.adult,
      noOfChildren: details?.passenger?.child,
      noOfInfants: details?.passenger?.infant,
      seniorCitizen: details?.passenger?.seniorcitizen,
      totalPassengers: details?.passenger?.total,
      pageSection: pageSectionConstants.FLIGHT_BOOKING
    };
  }

  if (eventName === event.ADD_PAX_DETAILS) {
    eventArray.event = event.ADD_PAX_DETAILS;
    eventArray["Special Assistance"] = false;
    eventArray["overall Details"] = details;

    eventArray.Mobility = "NA";
    eventArray.Impairments = "NA";
    // 'customerId' = 'NA';
    eventArray["overall Details"] = [{ ...details }];
    eventArray["special assistance for n.o traveller"] = 0;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    if (details.flowType && details.flowType === "CHECK_IN") {
      eventArray.email_address = details?.userData[0]?.emailId;
      eventArray.phone_no = details?.userData[0]?.mobile;
      window.Moengage.add_email(details?.userData[0]?.emailId);
      window.Moengage.add_mobile(details?.userData[0]?.mobile);
      eventArray.age = details?.userData[0]?.age;
      eventArray.destination_address = details?.userData[0]?.destinationAddress;
      eventArray.destination_pincode = details?.userData[0]?.destinationPin;
      eventArray["health _declaration_acknowledgement"] = true;
      eventArray.pnr = details?.currentBookingInStats?.recordLocator;
    } else {
      eventArray.emailId = details?.userData?.PRIMARY_CONTACT_DETAILS[0]?.email;
      window.Moengage.add_email(details?.userData?.PRIMARY_CONTACT_DETAILS[0]?.email);
     
      let userMobile = details?.userData?.PRIMARY_CONTACT_DETAILS[0]?.mobile;
      if (userMobile) {
        userMobile = userMobile.split("-");
        eventArray.mobile_number = `+${userMobile[1]}`;
        window.Moengage.add_mobile(userMobile[1]);
      }
    }

    const wheelchair = getSpecialyAbilityDetails(details?.currentBookingInStats?.passengerSegments);
    if (wheelchair) {
      eventArray["Special Assistance"] = wheelchair.isWheelchair;
      if (wheelchair.isWheelchair) {
        eventArray.Mobility = true;
      }
      eventArray["special assistance for n.o traveller"] = wheelchair.count;
    }
    eventArray.promoCode = getPromoCodeFromBookingInState(details?.currentBookingInStats);
    eventArray.FlightDetail = flightDetails(details?.currentBookingInStats, "", details?.bookingInRedux, details);
  }

  if (eventName === event.FC_GuestDetails_Submitted) {
    eventArray.event = event.FC_GuestDetails_Submitted;
    eventArray["Special Assistance"] = false;
    eventArray["overall Details"] = details;

    eventArray.Mobility = "NA";
    eventArray.Impairments = "NA";
    // 'customerId' = 'NA';
    eventArray["overall Details"] = [{ ...details }];
    eventArray["special assistance for n.o traveller"] = 0;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    if (details.flowType && details.flowType === "CHECK_IN") {
      eventArray.email_address = details?.userData[0]?.emailId;
      eventArray.phone_no = details?.userData[0]?.mobile;
      eventArray.age = details?.userData[0]?.age;
      eventArray.destination_address = details?.userData[0]?.destinationAddress;
      eventArray.destination_pincode = details?.userData[0]?.destinationPin;
      eventArray["health _declaration_acknowledgement"] = true;
      eventArray.pnr = details?.currentBookingInStats?.recordLocator;
    } else {
      eventArray.emailId = details?.userData?.PRIMARY_CONTACT_DETAILS[0]?.email;
      eventArray.mobile_number = details?.userData?.PRIMARY_CONTACT_DETAILS[0]?.mobile;
    }
    const wheelchair = getSpecialyAbilityDetails(details?.currentBookingInStats?.passengerSegments);
    if (wheelchair) {
      eventArray["Special Assistance"] = wheelchair.isWheelchair;
      if (wheelchair.isWheelchair) {
        eventArray.Mobility = true;
      }
      eventArray["special assistance for n.o traveller"] = wheelchair.count;
    }
    eventArray.promoCode = getPromoCodeFromBookingInState(details?.currentBookingInStats);
    eventArray.FlightDetail = flightDetails(details?.currentBookingInStats, "", details?.bookingInRedux, details);
  }

  if (eventName === event.ADDONS_SELECTED) {
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);

    let pageSectionAsParameter = PAGE_SECTION_VARIABLES.NEW_BOOKING;
    if (details?.flowType === FLOW_TYPE.CHECK_IN) {
      eventArray.event = event.FLIGHT_CHECKIN_ADDONS_SELECTED;
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    } else if (details?.flowType === FLOW_TYPE.MANAGE_BOOKING) {
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
      eventArray.event = event.ADDONS_SELECTED;
    } else if (details?.skip) {
      eventArray.event = event.ADDONS_SKIPED;
    } else {
      eventArray.event = event.ADDONS_SELECTED;
    }

    eventArray.FlightDetail = flightDetails(
      details?.bookingInState,
      pageSectionAsParameter,
      details?.bookingInRedux,
      details
    );

    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.excess_baggage_added = ssrCodeType.data.isExcessBag;
      eventArray.excess_baggage_count = ssrCodeType.data.ExcessBagCount;
      eventArray.excess_baggage_price = ssrCodeType.data.ExcessBagPrice;

      eventArray.meals_added = ssrCodeType.data.isMeal;
      eventArray.meals_count = ssrCodeType.data.MealCount;
      eventArray.meals_price = ssrCodeType.data.MealPrice;

      eventArray["priority_check-in_added"] = ssrCodeType.data.isPriorityBaggage;
      eventArray["priority_check-in_count"] = ssrCodeType.data.PriorityBaggageCount;
      eventArray["priority_check-in_price"] = ssrCodeType.data.PriorityBaggagePrice;

      eventArray.priority_boarding_added = ssrCodeType.data.isBoarding;
      eventArray.priority_boarding_count = ssrCodeType.data.BoardingCount;
      eventArray.priority_boarding_price = ssrCodeType.data.BoardingPrice;

      eventArray.seat_selected_added = ssrCodeType.data.isSeatSelected;
      eventArray.seat_selected_count = ssrCodeType.data.SeatSelectedCount;
      eventArray.total_seat_price = ssrCodeType.data.SeatSelectedPrice;

      eventArray.delay_cover_added = ssrCodeType.data.isDelayCover;
      eventArray.delay_cover_count = ssrCodeType.data.DelayCoverCount;
      eventArray.delay_cover_price = ssrCodeType.data.DelayCoverPrice;

      eventArray.lounge_added = ssrCodeType.data.isLounge;
      eventArray.lounge_price = ssrCodeType.data.LoungePrice;
      eventArray.lounge_count = ssrCodeType.data.LoungeCount;

      eventArray.travel_insurance_added = ssrCodeType.data.isTravelInsurance;
      eventArray.travel_insurance_price = ssrCodeType.data.TravelInsurancePrice;
      eventArray.travel_insurance_count = ssrCodeType.data.TravelInsuranceCount;

      eventArray.delay_and_lost_baggage_added = ssrCodeType.data.isDelayAndLostBaggage;
      eventArray.delay_and_lost_baggage_price = ssrCodeType.data.DelayAndLostBaggagePrice;
      eventArray.delay_and_lost_baggage_count = ssrCodeType.data.DelayAndLostBaggageCount;
      
      eventArray.delay_and_lost_baggage_added = details?.bookingInRedux?.runningAddhons.DLBG.isActive;
      eventArray.delay_and_lost_baggage_price = details?.bookingInRedux?.addhosFare.DLBG;

      // eventArray.seat_no = getAllSeatsNumberOfPax(details?.passengerSummary)?.seatsNos;

      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
      eventArray.total_addon_price = ssrCodeType.data.totalAmount;
    }


    eventArray.primary_contact_email = details?.bookingInState?.contacts[0]?.emailAddress;
    eventArray.primary_contact_phone_number = details?.bookingInState?.contacts[0]?.phoneNumbers[0]?.number;

    eventArray.skipped = details?.skip ? details?.skip : false;

    eventArray.promoCode = getPromoCodeFromBookingInState(details?.bookingInState);
  }

  if (eventName === event.CHECKIN_ADDONS) {
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);

    let pageSectionAsParameter = PAGE_SECTION_VARIABLES.NEW_BOOKING;
    if (details?.flowType === FLOW_TYPE.CHECK_IN) {
      eventArray.event = event.FLIGHT_CHECKIN_ADDONS_SELECTED;
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    } else if (details?.flowType === FLOW_TYPE.MANAGE_BOOKING) {
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
      eventArray.event = event.ADDONS_SELECTED;
    } else if (details?.skip) {
      eventArray.event = event.ADDONS_SKIPED;
    } else {
      eventArray.event = event.ADDONS_SELECTED;
    }


    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.excess_baggage_added = ssrCodeType.data.isExcessBag;
      eventArray.excess_baggage_count = ssrCodeType.data.ExcessBagCount;
      eventArray.excess_baggage_price = ssrCodeType.data.ExcessBagPrice;

      eventArray.meals_added = ssrCodeType.data.isMeal;
      eventArray.meals_count = ssrCodeType.data.MealCount;
      eventArray.meals_price = ssrCodeType.data.MealPrice;

      eventArray["priority_check-in_added"] = ssrCodeType.data.isPriorityBaggage;
      eventArray["priority_check-in_count"] = ssrCodeType.data.PriorityBaggageCount;
      eventArray["priority_check-in_price"] = ssrCodeType.data.PriorityBaggagePrice;

      eventArray.priority_boarding_added = ssrCodeType.data.isBoarding;
      eventArray.priority_boarding_count = ssrCodeType.data.BoardingCount;
      eventArray.priority_boarding_price = ssrCodeType.data.BoardingPrice;

      eventArray.seat_selected_added = ssrCodeType.data.isSeatSelected;
      eventArray.seat_selected_count = ssrCodeType.data.SeatSelectedCount;
      eventArray.total_seat_price = ssrCodeType.data.SeatSelectedPrice;

      eventArray.delay_cover_added = ssrCodeType.data.isDelayCover;
      eventArray.delay_cover_count = ssrCodeType.data.DelayCoverCount;
      eventArray.delay_cover_price = ssrCodeType.data.DelayCoverPrice;

      eventArray.lounge_added = ssrCodeType.data.isLounge;
      eventArray.lounge_price = ssrCodeType.data.LoungePrice;
      eventArray.lounge_count = ssrCodeType.data.LoungeCount;

      eventArray.travel_insurance_added = ssrCodeType.data.isTravelInsurance;
      eventArray.travel_insurance_price = ssrCodeType.data.TravelInsurancePrice;
      eventArray.travel_insurance_count = ssrCodeType.data.TravelInsuranceCount;

      eventArray.delay_and_lost_baggage_added = ssrCodeType.data.isDelayAndLostBaggage;
      eventArray.delay_and_lost_baggage_price = ssrCodeType.data.DelayAndLostBaggagePrice;
      eventArray.delay_and_lost_baggage_count = ssrCodeType.data.DelayAndLostBaggageCount;

      // eventArray.seat_no = getAllSeatsNumberOfPax(details?.passengerSummary)?.seatsNos;

      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
      eventArray.total_addon_price = ssrCodeType.data.totalAmount;
    }

    eventArray.primary_contact_email = details?.bookingInState?.contacts[0]?.emailAddress;
    eventArray.primary_contact_phone_number = details?.bookingInState?.contacts[0]?.phoneNumbers[0]?.number;

    eventArray.skipped = details?.skip ? details?.skip : false;

    eventArray.promoCode = getPromoCodeFromBookingInState(details?.bookingInState);
  }

  if (eventName === event.FLIGHT_SEAT_SELECTED) {
    let pageSectionAsParameter;

    if (details?.flowType === FLOW_TYPE.CHECK_IN) {
      eventArray.event = event.FLIGHT_CHECKIN_SEAT_SELECTED;
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    } else {
      eventArray.event = event.FLIGHT_SEAT_SELECTED;
    }

    eventArray.departure_from = details?.bookingInState?.journeys[0].designator.origin;
    eventArray.departure_to = details?.bookingInState?.journeys[0].designator.destination;

    eventArray.return_from = details?.bookingInState?.journeys.length > 1 ?   details?.bookingInState?.journeys[1].designator.origin : null;
    eventArray.return_to = details?.bookingInState?.journeys.length > 1 ?  details?.bookingInState?.journeys[1].designator.destination : null;

    eventArray.passenger_count = details?.passenger?.total;
    eventArray.primary_contact_email = details?.bookingInState?.contacts[0]?.emailAddress;
    eventArray.primary_contact_phone_number = details?.bookingInState?.contacts[0]?.phoneNumbers[0]?.number;
    eventArray.customer_name =
      details?.bookingInState?.contacts[0]?.name?.first + " " + details?.bookingInState?.contacts[0]?.name?.last;

    eventArray.seat_no = details?.seatSelectedWithPassenger?.map((o) => o.designator)?.join(",");

    eventArray.departure_seat_no = details?.seatSelectedWithPassenger[0]?.designator;
    eventArray.return_seat_no = details?.seatSelectedWithPassenger[1]?.designator || null;

    eventArray.total_no_seats = details?.seatSelectedWithPassenger?.length;
    eventArray.total_seat_price = details?.seatSelectedWithPassenger
      ?.map((o) => o.seatPrice)
      ?.reduce((previousValue, currentValue) => previousValue + currentValue, 0);

    eventArray.currency = details?.selectedCurrency;
    eventArray.flowType = details?.flowType ? details?.flowType : FLOW_TYPE.NEW_BOOKING;
    eventArray.promoCode = getPromoCodeFromBookingInState(details?.bookingInState);
    // eventArray.pnr = details?.bookingInState?.recordLocator;
    eventArray.skipped = details?.skip ? details?.skip : false;
  }

  if (eventName === event.FLIGHT_CHECKIN_SEAT_SELECTED) {
    eventArray.departure_from = details?.bookingInState?.journeys[0].designator.origin || null;
    eventArray.departure_to = details?.bookingInState?.journeys[0].designator.destination || null;

    eventArray.return_from = details?.bookingInState?.journeys[1]?.designator?.origin || null;
    eventArray.return_to = details?.bookingInState?.journeys[1]?.designator?.destination || null;

    eventArray.passenger_count = details?.passenger?.total || null;
    eventArray.primary_contact_email = details?.bookingInState?.contacts[0]?.emailAddress || null;
    eventArray.primary_contact_phone_number = details?.bookingInState?.contacts[0]?.phoneNumbers[0]?.number || null;
    eventArray.customer_name =
      details?.bookingInState?.contacts[0]?.name?.first + " " + details?.bookingInState?.contacts[0]?.name?.last ||
      null;

    eventArray.seat_amount = details?.bookingInState?.breakdown?.passengerTotals?.seats?.total

    eventArray.currency = details?.selectedCurrency || null;

    eventArray.flowType = details?.flowType || null;
    eventArray.promoCode = getPromoCodeFromBookingInState(details?.bookingInState) || null;
    eventArray.pnr = details?.bookingInState?.recordLocator;
    // eventArray.skipped = details?.skip ?? false;
  }

  if (eventName === event.PAYMENT_INITIATED) {
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);

    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
    }
    eventArray.event = event.PAYMENT_INITIATED;
    eventArray.orderId = details?.orderId;
    eventArray.amount = details?.amount;
    eventArray.flowType = details?.flowType ? details?.flowType : FLOW_TYPE.NEW_BOOKING;

    eventArray["Flight Name"] = getNSegmentName(details?.currentBooking?.journeys, 0);
    eventArray["Journey Type"] = getJourneyType(details?.currentBooking?.journeys);
    eventArray.PNR = details?.currentBooking?.recordLocator;
    eventArray["Return arrival date"] =
      details?.currentBooking?.journeys.length > 1 && details?.currentBooking?.journeys[1]?.designator?.arrival
        ? details?.currentBooking?.journeys[1]?.designator?.arrival
        : "";
    eventArray["Return depart date"] =
      details?.currentBooking?.journeys.length > 1 && details?.currentBooking?.journeys[1]?.designator?.departure
        ? details?.currentBooking?.journeys[1]?.designator?.departure
        : "";
    eventArray["Return flight name"] = getNSegmentName(details?.currentBooking?.journeys, 1);
    eventArray["Departure flight name"] = getNSegmentName(details?.currentBooking?.journeys, 0);

    eventArray.option_selected = getFlightNameWithProductClassType(details?.currentBooking?.journeys, 0);
    eventArray.return_option_selected =
      details?.currentBooking?.journeys != 1
        ? getFlightNameWithProductClassType(details?.currentBooking?.journeys, 1)
        : "";

    eventArray.source = details?.currentBooking?.journeys[0]?.designator.origin;
    eventArray.destination = details?.currentBooking?.journeys[0]?.designator.destination;

    eventArray.departueNoOfStops = details?.currentBooking?.journeys[0]?.stops;
    eventArray.returnNoOfStops = details?.currentBooking?.journeys[1]?.stops;

    eventArray.departureLocation = details?.origin?.cityInfo?.name;
    eventArray.returnLocation = details?.destination?.cityInfo?.name;

    eventArray.flight_type = details?.currentBooking?.journeys.length === 1 ? "ONE_WAY" : "ROUND_TRIP";
    eventArray["Arrival Date and time"] =
      subtractTimeFromDate(details?.currentBooking?.journeys[0]?.designator?.arrival) || null;
    eventArray["Booking id"] = details?.currentBooking?.bookingKey;
    eventArray.Currency = details?.selectedCurrency;
    eventArray["Departure Date and time"] =
      subtractTimeFromDate(details?.currentBooking?.journeys[0]?.designator?.departure)|| null;

    eventArray.arrival_terminal = details?.flightDetails?.arrivalTerminal;
    eventArray.departure_terminal = details?.flightDetails?.departureTerminal;
    eventArray.no_of_layover = details?.flightDetails?.Noofstops.length;
    eventArray.specialfares = details?.selectedSpecialFare?.name;
    eventArray.departureCity = details?.flightDetails?.originStation;
    eventArray.arrivalCity = details?.flightDetails?.destinationStation;

    eventArray.departure_terminal =
      details?.currentBooking?.journeys[0]?.segments[0]?.legs[0].legInfo.departureTerminal;
    eventArray.return_terminal = details?.currentBooking?.journeys[1]?.segments[0]?.legs[0].legInfo.departureTerminal;

    eventArray.addons_purchase = Object.keys(details?.bookingSummaryBreakUp.ADHONS);
    eventArray.plan_amount = details?.amount;

    if (details.user) {
      // eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
  }

  if (eventName === event.CHECKIN_PAYMENT_INITIATED) {
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);

    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
    }
    eventArray.orderId = details?.orderId;
    eventArray.amount = details?.amount;

    eventArray["Flight Name"] = getNSegmentName(details?.currentBooking?.journeys, 0);
    eventArray["Journey Type"] = getJourneyType(details?.currentBooking?.journeys);
    eventArray.PNR = details?.currentBooking?.recordLocator;
    eventArray["Return arrival date"] =
      details?.currentBooking?.journeys.length > 1 && details?.currentBooking?.journeys[1]?.designator?.arrival
        ? details?.currentBooking?.journeys[1]?.designator?.arrival
        : "";
    eventArray["Return depart date"] =
      details?.currentBooking?.journeys.length > 1 && details?.currentBooking?.journeys[1]?.designator?.departure
        ? details?.currentBooking?.journeys[1]?.designator?.departure
        : "";
    eventArray["Return flight name"] =
      details?.currentBooking?.journeys.length > 1 ? getNSegmentName(details?.currentBooking?.journeys, 1) : null;
    eventArray["Departure flight name"] = getNSegmentName(details?.currentBooking?.journeys, 0);

    eventArray.option_selected = getFlightNameWithProductClassType(details?.currentBooking?.journeys, 0);
    eventArray.return_option_selected =
      details?.currentBooking?.journeys !== 1
        ? getFlightNameWithProductClassType(details?.currentBooking?.journeys, 1)
        : "";

    eventArray.source = details?.currentBooking?.journeys[0]?.designator.origin;
    eventArray.destination = details?.currentBooking?.journeys[0]?.designator.destination;

    eventArray.departueNoOfStops = details?.currentBooking?.journeys[0]?.stops;
    eventArray.returnNoOfStops =
      details?.currentBooking?.journeys.length > 1 ? details?.currentBooking?.journeys[1]?.stops : null;

    eventArray.departureLocation = details?.origin?.cityInfo?.name;
    eventArray.returnLocation =
      details?.currentBooking?.journeys.length > 1 ? details?.destination?.cityInfo?.name : null;

    eventArray["Arrival Date and time"] =
      subtractTimeFromDate(details?.currentBooking?.journeys[0]?.designator?.arrival) || null;
    eventArray["Booking id"] = details?.currentBooking?.bookingKey;
    eventArray.Currency = details?.selectedCurrency;
    eventArray["Departure Date and time"] =
    subtractTimeFromDate(details?.currentBooking?.journeys[0]?.designator?.departure) || null;

    eventArray.departure_terminal =
      details?.currentBooking?.journeys[0]?.segments[0]?.legs[0].legInfo.departureTerminal;
    eventArray.return_terminal =
      details?.currentBooking?.journeys.length > 1
        ? details?.currentBooking?.journeys[1]?.segments[0]?.legs[0].legInfo.departureTerminal
        : null;

    eventArray.addons_purchase = Object.keys(details?.bookingSummaryBreakUp.ADHONS);

    if (details.user) {
      // eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
  }

  if (eventName === event.BOOKING_SUMMARY) {
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);

    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
    }
    eventArray.event = event.PAYMENT_INITIATED;
    eventArray.orderId = details?.orderId;
    eventArray.amount = details?.amount;
    eventArray.flowType = details?.flowType ? details?.flowType : FLOW_TYPE.NEW_BOOKING;

    eventArray["Flight Name"] = getNSegmentName(details?.currentBooking?.journeys, 0);
    eventArray["Journey Type"] = getJourneyType(details?.currentBooking?.journeys);
    // eventArray["Overall Details"] = { ...details };
    eventArray.PNR = details?.currentBooking?.recordLocator;
    eventArray["Return arrival date"] =
      details?.currentBooking?.journeys.length > 1 && details?.currentBooking?.journeys[1]?.designator?.arrival
        ? details?.currentBooking?.journeys[1]?.designator?.arrival
        : "";
    eventArray["Return depart date"] =
      details?.currentBooking?.journeys.length > 1 && details?.currentBooking?.journeys[1]?.designator?.departure
        ? details?.currentBooking?.journeys[1]?.designator?.departure
        : "";
    eventArray["Return flight name"] = getNSegmentName(details?.currentBooking?.journeys, 1);
    eventArray["Departure flight name"] = getNSegmentName(details?.currentBooking?.journeys, 0);

    eventArray.option_selected = getFlightNameWithProductClassType(details?.currentBooking?.journeys, 0);
    eventArray.return_option_selected =
      details?.currentBooking?.journeys != 1
        ? getFlightNameWithProductClassType(details?.currentBooking?.journeys, 1)
        : "";

    eventArray.source = details?.currentBooking?.journeys[0]?.designator.origin;
    eventArray.destination = details?.currentBooking?.journeys[0]?.designator.destination;

    // eventArray.departureNoOfStops = details?.currentBooking?.journeys[0]?.stops;
    eventArray.returnNoOfStops = details?.currentBooking?.journeys[1]?.stops;

    eventArray.departureLocation = details?.origin?.cityInfo?.name;
    eventArray.returnLocation = details?.destination?.cityInfo?.name;

    eventArray.flight_type = details?.currentBooking?.journeys.length === 1 ? "ONE_WAY" : "ROUND_TRIP";
    eventArray["Arrival Date and time"] = subtractTimeFromDate(details?.currentBooking?.journeys[0]?.designator?.arrival);
    eventArray["Booking id"] = details?.currentBooking?.bookingKey;
    eventArray.Currency = details?.selectedCurrency;
    eventArray["Departure Date and time"] = subtractTimeFromDate(details?.currentBooking?.journeys[0]?.designator?.departure)

    eventArray.arrival_terminal = details?.flightDetails?.arrivalTerminal;
    eventArray.departure_terminal = details?.flightDetails?.departureTerminal;
    eventArray.no_of_layover = details?.flightDetails?.Noofstops.length;
    eventArray.specialfares = details?.selectedSpecialFare?.name;
    eventArray.departureCity = details?.flightDetails?.originStation;
    eventArray.arrivalCity = details?.flightDetails?.destinationStation;

    eventArray.departure_terminal =
      details?.currentBooking?.journeys[0]?.segments[0]?.legs[0].legInfo.departureTerminal;
    eventArray.return_terminal = details?.currentBooking?.journeys[1]?.segments[0]?.legs[0].legInfo.departureTerminal;

    eventArray.addons_purchase = Object.keys(details?.bookingSummaryBreakUp.ADHONS);
    // eventArray.plan_amount = details?.amount;

    if (details.user) {
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
  }

  if (eventName === event.PAYMENT_FAILED) {
    eventArray.event = event.PAYMENT_FAILED;
    eventArray.orderId = details?.orderId;
    eventArray["booking id"] = details?.orderId;
    eventArray.total_price = details?.amount;
    eventArray.reason = "";
    eventArray.pnr = details?.bookingInState?.recordLocator;

    eventArray.flowType = details?.flowType ? details?.flowType : FLOW_TYPE.NEW_BOOKING;
  }
  //

  if (eventName === event.BOOKING_SUCCESSFUL) {
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);

    let pageSectionAsParameter;

    if (details.isChangeBooking) {
      eventArray.event = event.BOOKING_CHANGED;
      eventArray.old_departure_date = subtractTimeFromDate(details?.changeBookingOldDate?.journeys[0]?.designator?.arrival)
      pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
    } else {
      eventArray.event = eventName;
    }

    eventArray.flight_type = details?.bookingInState?.journeys.length === 1 ? "ONE_WAY" : "ROUND_TRIP";
    eventArray["Arrival Date and time"] = subtractTimeFromDate(details?.bookingInState?.journeys[0]?.designator?.arrival)
    eventArray["Booking id"] = details?.bookingInState?.bookingKey;
    eventArray.Currency = details?.selectedCurrency;
    eventArray["Departure Date and time"] = subtractTimeFromDate(details?.bookingInState?.journeys[0]?.designator?.departure)

    eventArray.source = details?.origin?.cityInfo?.cityCode;
    eventArray.destination = details?.destination?.cityInfo?.cityCode;

    eventArray.departueNoOfStops = details?.bookingInState?.journeys[0]?.stops;
    eventArray.returnNoOfStops = details?.bookingInState?.journeys[1]?.stops;

    eventArray.departureLocation = details?.origin?.cityInfo?.name;
    eventArray.returnLocation = details?.destination?.cityInfo?.name;

    eventArray["Flight Name"] = getNSegmentName(details?.bookingInState?.journeys, 0);
    eventArray["Journey Type"] = getJourneyType(details?.bookingInState?.journeys);
    eventArray.PNR = details?.bookingInState?.recordLocator;
    eventArray["Return arrival date"] =
      details?.bookingInState?.journeys.length > 1 && details?.bookingInState?.journeys[1]?.designator?.arrival
        ? details?.bookingInState?.journeys[1]?.designator?.arrival
        : "";
    eventArray["Return depart date"] =
      details?.bookingInState?.journeys.length > 1 && details?.bookingInState?.journeys[1]?.designator?.departure
        ? details?.bookingInState?.journeys[1]?.designator?.departure
        : "";
    eventArray["Return flight name"] = getNSegmentName(details?.bookingInState?.journeys, 1);
    eventArray.option_selected = getFlightNameWithProductClassType(details?.bookingInState?.journeys, 0);
    eventArray.return_option_selected =
      details?.bookingInState?.journeys != 1
        ? getFlightNameWithProductClassType(details?.bookingInState?.journeys, 1)
        : "";

    eventArray.noOfAdults = details?.passenger?.adult;
    eventArray.noOfChildren = details?.passenger?.child;
    eventArray.noOfInfants = details?.passenger?.infant;
    eventArray.seniorCitizen = details?.passenger?.seniorcitizen;
    eventArray.totalPassengers = details?.passenger?.total;
    eventArray.total_price = details?.bookingInState?.breakdown?.authorizedBalanceDue;
    eventArray.promoCode = getPromoCodeFromBookingInState(details?.bookingInState);

    eventArray.primary_contact_phone_number = details?.bookingInState?.contacts[0]?.phoneNumbers[0]?.number;
    eventArray.primary_contact_email = details?.bookingInState?.contacts[0]?.emailAddress;
    eventArray.primary_first_name = details?.bookingInState?.contacts[0]?.name?.first;
    eventArray.specialfares = details.selectedSpecialFare?.name;
    eventArray.total_amount = details?.balanceAmount
    eventArray.basefare = details?.bookingInState?.breakdown?.journeyTotals?.totalAmount;
    eventArray.departure_plan_name = details?.bookingInState?.journeys[0]?.segments[0]?.fares[0]?.productClass === "EC" ? "Saver" : "Flexi";
    eventArray.return_plan_name = details?.bookingInState?.journeys[1]?.segments[0]?.fares[0]?.productClass === "EC" ? "Saver" : "Flexi";


    eventArray.FlightDetail = flightDetails(
      details?.bookingInState,
      pageSectionAsParameter,
      details?.bookingInRedux,
      details
    );
    const taxessum = getSumOfTax(details?.bookingSummaryBreakUp?.tax);

    eventArray.taxes = taxessum;

    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.excess_baggage_added = ssrCodeType.data.isExcessBag;
      eventArray.excess_baggage_count = ssrCodeType.data.ExcessBagCount;
      eventArray.excess_baggage_price = ssrCodeType.data.ExcessBagPrice;

      eventArray.meals_added = ssrCodeType.data.isMeal;
      eventArray.meals_count = ssrCodeType.data.MealCount;
      eventArray.meals_price = ssrCodeType.data.MealPrice;

      eventArray["priority_check-in_added"] = ssrCodeType.data.isPriorityBaggage;
      eventArray["priority_check-in_count"] = ssrCodeType.data.PriorityBaggageCount;
      eventArray["priority_check-in_price"] = ssrCodeType.data.PriorityBaggagePrice;

      eventArray.priority_boarding_added = ssrCodeType.data.isBoarding;
      eventArray.priority_boarding_count = ssrCodeType.data.BoardingCount;
      eventArray.priority_boarding_price = ssrCodeType.data.BoardingPrice;

      eventArray.seat_selected_added = ssrCodeType.data.isSeatSelected;
      eventArray.seat_selected_count = ssrCodeType.data.SeatSelectedCount;
      eventArray.total_seat_price = ssrCodeType.data.SeatSelectedPrice;

      eventArray.delay_cover_added = ssrCodeType.data.isDelayCover;
      eventArray.delay_cover_count = ssrCodeType.data.DelayCoverCount;
      eventArray.delay_cover_price = ssrCodeType.data.DelayCoverPrice;

      eventArray.lounge_added = ssrCodeType.data.isLounge;
      eventArray.lounge_price = ssrCodeType.data.LoungePrice;
      eventArray.lounge_count = ssrCodeType.data.LoungeCount;

      eventArray.travel_insurance_added = ssrCodeType.data.isTravelInsurance;
      eventArray.travel_insurance_price = ssrCodeType.data.TravelInsurancePrice;
      eventArray.travel_insurance_count = ssrCodeType.data.TravelInsuranceCount;

      eventArray.delay_and_lost_baggage_added = ssrCodeType.data.isDelayAndLostBaggage;
      eventArray.delay_and_lost_baggage_price = ssrCodeType.data.DelayAndLostBaggagePrice;
      eventArray.delay_and_lost_baggage_count = ssrCodeType.data.DelayAndLostBaggageCount;

      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
      eventArray.total_addon_price = ssrCodeType.data.totalAmount;
    }

    // if (details.user) {
    //   eventArray.customerId = details.user.cusExternalId;
    //   eventArray.userType = LOGIN_USER;
    // } else {
    //   eventArray.userType = GUEST_USER;
    // }
    const wheelchair = getSpecialyAbilityDetails(details?.bookingInState?.passengerSegments);
    if (wheelchair) {
      eventArray["Special Assistance"] = wheelchair.isWheelchair;
      if (wheelchair.isWheelchair) {
        eventArray.Mobility = true;
      } else {
        eventArray.Mobility = false;
      }
      eventArray["special assistance for n.o traveller"] = wheelchair.count;
    }
  }

  if (eventName === event.CHECKIN_SUCCESSFULL) {
    eventArray.event = event.CHECKIN_SUCCESSFULL;
    const ssrCodeType = adhosType(details?.bookingSummaryBreakUp?.ADHONS);
    var source;
    var destination;
    if (details?.passengerSummary && typeof details?.passengerSummary === "object") {
      var keys = Object.keys(details?.passengerSummary);
      if (keys.length) {
        if (keys[0].split("-").length === 2) {
          source = keys[0].split("-")[0];
          destination = keys[0].split("-")[1];
        }
      }
    }

    eventArray["Arrival Date and time"] = subtractTimeFromDate(details?.bookingInState?.journeys[0]?.designator?.arrival)
    eventArray["Booking id"] = details?.bookingInState?.bookingKey;
    eventArray.Currency = details?.selectedCurrency;
    eventArray["Departure Date and time"] = subtractTimeFromDate(details?.bookingInState?.journeys[0]?.designator?.departure)

    eventArray.addons_purchase = Object.keys(details?.bookingSummaryBreakUp.ADHONS);
    eventArray.departure_location = source;
    eventArray.Destination = destination;
    eventArray.arrival_location = destination;
    eventArray["Flight Name"] = getNSegmentName(details?.bookingInState?.journeys, 0);
    eventArray["Journey Type"] = getJourneyType(details?.bookingInState?.journeys);
    eventArray.PNR = details?.bookingInState?.recordLocator;
    eventArray["Return arrival date"] =
      details?.bookingInState?.journeys.length > 1 && details?.bookingInState?.journeys[1]?.designator?.arrival
        ?  subtractTimeFromDate(details?.bookingInState?.journeys[1]?.designator?.arrival)
        : "";
    eventArray["Return depart date"] =
      details?.bookingInState?.journeys.length > 1 && details?.bookingInState?.journeys[1]?.designator?.departure
        ? subtractTimeFromDate(details?.bookingInState?.journeys[1]?.designator?.departure)
        : "";
    eventArray["Return flight name"] = details?.bookingInState?.journeys.length > 1 && getNSegmentName(details?.bookingInState?.journeys, 1);
    eventArray["total Price"] = details?.bookingInState?.breakdown?.totalAmount;
    eventArray.phone_no = details?.bookingInState?.contacts[0]?.phoneNumbers[0]?.number;
    eventArray.email_address = details?.bookingInState?.contacts[0]?.emailAddress;
    eventArray.health_declaration_acknowledgement = true;
    eventArray.goods_declaration_acknowledgement = true;
    eventArray.promo_code = getPromoCodeFromBookingInState(details?.bookingInState);
    eventArray.last_name = details?.bookingInState?.contacts[0]?.name?.last;
    const pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    eventArray.FlightDetail = flightDetails(
      details?.bookingInState,
      pageSectionAsParameter,
      details?.bookingInRedux,
      details
    );
    // if (details.user) {
    //   eventArray.customerId = details.user.cusExternalId;
    //   eventArray.userType = LOGIN_USER;
    // } else {
    //   eventArray.userType = GUEST_USER;
    // }

    if (ssrCodeType.status && ssrCodeType.data) {
      eventArray.excess_baggage_added = ssrCodeType.data.isExcessBag;
      eventArray.excess_baggage_count = ssrCodeType.data.ExcessBagCount;
      eventArray.excess_baggage_price = ssrCodeType.data.ExcessBagPrice;

      eventArray.meals_added = ssrCodeType.data.isMeal;
      eventArray.meals_count = ssrCodeType.data.MealCount;
      eventArray.meals_price = ssrCodeType.data.MealPrice;

      eventArray["priority_check-in_added"] = ssrCodeType.data.isPriorityBaggage;
      eventArray["priority_check-in_count"] = ssrCodeType.data.PriorityBaggageCount;
      eventArray["priority_check-in_price"] = ssrCodeType.data.PriorityBaggagePrice;

      eventArray.priority_boarding_added = ssrCodeType.data.isBoarding;
      eventArray.priority_boarding_count = ssrCodeType.data.BoardingCount;
      eventArray.priority_boarding_price = ssrCodeType.data.BoardingPrice;

      eventArray.seat_selected_added = ssrCodeType.data.isSeatSelected;
      eventArray.seat_selected_count = ssrCodeType.data.SeatSelectedCount;
      eventArray.total_seat_price = ssrCodeType.data.SeatSelectedPrice;

      eventArray.delay_cover_added = ssrCodeType.data.isDelayCover;
      eventArray.delay_cover_count = ssrCodeType.data.DelayCoverCount;
      eventArray.delay_cover_price = ssrCodeType.data.DelayCoverPrice;

      eventArray.lounge_added = ssrCodeType.data.isLounge;
      eventArray.lounge_price = ssrCodeType.data.LoungePrice;
      eventArray.lounge_count = ssrCodeType.data.LoungeCount;

      eventArray.travel_insurance_added = ssrCodeType.data.isTravelInsurance;
      eventArray.travel_insurance_price = ssrCodeType.data.TravelInsurancePrice;
      eventArray.travel_insurance_count = ssrCodeType.data.TravelInsuranceCount;

      eventArray.delay_and_lost_baggage_added = ssrCodeType.data.isDelayAndLostBaggage;
      eventArray.delay_and_lost_baggage_price = ssrCodeType.data.DelayAndLostBaggagePrice;
      eventArray.delay_and_lost_baggage_count = ssrCodeType.data.DelayAndLostBaggageCount;

      // eventArray.seat_no = getAllSeatsNumberOfPax(details?.passengerSummary)?.seatsNos;

      eventArray.total_added = ssrCodeType.data.totalAddonsCount;
      eventArray.total_addon_price = ssrCodeType.data.totalAmount;
    }
    // if (details.user) {
    //   eventArray.customerId = details.user.cusExternalId;
    //   eventArray.userType = LOGIN_USER;
    // } else {
    //   eventArray.userType = GUEST_USER;
    // }
  }
  if (eventName === event.SIGNUP_SUCCESS) {
    eventArray.event = event.SIGNUP_SUCCESS;
  }
  if (eventName === event.CHECKIN_ACCEPT_NO_DANGEROURS_GOOD) {
    eventArray.event = event.CHECKIN_ACCEPT_NO_DANGEROURS_GOOD;
    eventArray["goods _declaration_acknowledgement"] = true;
    eventArray.pnr = details?.currentBooking?.recordLocator;
    eventArray.source = "check-in page";
    eventArray.flight_name = "";
  }
  if (eventName === event.LOGIN_SUCCESS) {
    eventArray.event = event.LOGIN_SUCCESS;
    eventArray.customerId = details?.user.cusLoyaltyId;
    eventArray.first_name = details?.user.cusFName;
    eventArray.last_name = details?.user.cusLName;
    eventArray.emailId = details?.user.cusEmail;
    eventArray.gender = details?.user.cspGender === "M" ? "Male" : "Female";
    eventArray.mobile_number = details?.user.cusMobileCountryCode + details?.user.cusMobile;
    eventArray.dob = details?.user.cspCustomerBirthday?.split("-")?.reverse()?.join("/");
  }
  if (eventName === event.LOGOUT_SUCCESS) {
    eventArray.event = event.LOGOUT_SUCCESS;
  }
  if (eventName === event.NEWS_LETTER_SIGNUP) {
    eventArray.event = event.NEWS_LETTER_SIGNUP;
    eventArray.email = details.email;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    if (details.unsubUrl) {
      eventArray.cp_unsubscribe_link_id = details.unsubUrl;
    }
  }
  if (eventName === event.CHECKIN_INIT) {
    eventArray.event = event.CHECKIN_INIT;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }

    eventArray.pnr = details.currentBookingInState?.recordLocator;
    eventArray.emailId = details.currentBookingInState?.contacts[0]?.value?.emailAddress;
    eventArray.last_name = details.currentBookingInState?.contacts[0]?.value?.name?.last;
    const pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    eventArray.FlightDetail = flightDetails(details.currentBookingInState, pageSectionAsParameter, null, details);
  }
  if (eventName === event.FC_CLICKED_ON_SELECT_ADDONS) {
    eventArray.event = event.FC_CLICKED_ON_SELECT_ADDONS;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }

    // eventArray.emergency_contact_number = details?.emergencyContact?.phone;
    // eventArray.emergency_contact_name = details?.emergencyContact?.name;
    // eventArray.emergency_contact_country_name = details?.emergencyContact?.country;
    // eventArray.whatsapp_opt_in_status = details?.whatsappOptInStatus;
    eventArray.journey_type = getJourneyType(details?.currentBookingInState?.journeys);
    eventArray.total_number_of_passangers = details?.currentBookingInState?.passengers.length;
    eventArray.check_in_passanger_count = details?.passengerSummary?.total;
    eventArray.check_in_passanger_details = details?.passengerSummary;  
    eventArray.departure_station = details?.currentBookingInState?.journeys[0]?.designator?.origin; 
    eventArray.arrival_station = details?.currentBookingInState?.journeys[0]?.designator?.destination;
    eventArray.departure_terminal = details?.flightDetails?.departureTerminal;
    eventArray.arrival_terminal = details?.flightDetails?.arrivalTerminal;


    eventArray.pnr = details.currentBookingInState?.recordLocator;

    eventArray.emailId = details.currentBookingInState?.contacts[0]?.emailAddress;
    eventArray.last_name = details.currentBookingInState?.contacts[0]?.name?.last;
    eventArray.phone_no = String(details.currentBookingInState?.contacts[0]?.phoneNumbers[0]?.number).slice(3) ;
    window.Moengage.add_email(details.currentBookingInState?.contacts[0]?.emailAddress);
    let cleanedNumber = String(details.currentBookingInState?.contacts[0]?.phoneNumbers[0]?.number).slice(3) 
    window.Moengage.add_mobile(cleanedNumber);
    const pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
    eventArray.FlightDetail = flightDetails(
      details.currentBookingInState,
      pageSectionAsParameter,
      details?.bookingInRedux,
      details
    );
  }

  if (eventName === event.CANCELED_BOOKING) {
    eventArray.event = event.CANCELED_BOOKING;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    eventArray.pnr = details.currentBookingInState?.recordLocator;
    eventArray.emailId = details.currentBookingInState?.contacts[0]?.value?.emailAddress;
    eventArray.last_name = details.currentBookingInState?.contacts[0]?.value?.name?.last;
    eventArray["Booking id"] = details?.currentBookingInState?.bookingKey;
    const pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
    eventArray.FlightDetail = flightDetails(details.currentBookingInState, pageSectionAsParameter, null, details);
  }

  if (eventName === event.RETRIVE_BOOKING_WITH_PNR) {
    eventArray.event = event.MANAGE_BOOKING_PNR_DETAILS;
    if (details?.pageType === "EXCESS_BAGGAGE") {
      eventArray.event = event.EXCESS_BAGGAGE_INIT;
    }
    if (details?.pageType === "FOOD_BEVERAGE") {
      eventArray.event = event.CAFE_AKASA;
    }
    if (details?.pageType === "SEAT_SELECT") {
      eventArray.event = event.SELECT_YOUR_SEAT;
    }
    if (details?.pageType === "PRIORITY_CHECK_IN_AND_BAG") {
      eventArray.event = event.PRIORITY_CHECKIN;
    }
    if (details?.pageType === "BOARD_FIRST") {
      eventArray.event = event.BOARD_FIRST;
    }
    if (details?.pageType === "CHECK_IN") {
      eventArray.event = event.CHECKIN_RETRIVE_BOOKING;
    }
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }

    // eventArray["Flight Name"] = "QP" + details?.currentBookingInState?.journeys[0]?.segments[0]?.identifier?.identifier;

    eventArray["Flight Name"] = getNSegmentName(details?.currentBookingInState?.journeys, 0) + "," + getNSegmentName(details?.currentBookingInState?.journeys, 1) ;
    // eventArray["Return flight name"] = getNSegmentName(details?.currentBookingInState?.journeys, 1);

    eventArray.source = details?.source;
    eventArray.passenger = details?.currentBookingInState?.passengers.length;
    // eventArray["Departure Date and time"] = new Date(
    //   details?.currentBookingInState?.journeys[1]?.designator?.departure
    // );

    // eventArray["return Date and time"] =
    //   new Date(details?.currentBookingInState?.journeys[0]?.designator?.departure) || null;

    eventArray["Departure Station"] = details?.currentBookingInState?.journeys[0]?.designator?.origin
    eventArray["Arrival Station"] = details?.currentBookingInState?.journeys[0]?.designator?.destination

    eventArray.pnr = details.currentBookingInState?.recordLocator;
    eventArray.email = details?.userInput?.email || null;
    eventArray["last Name"] = details?.userInput?.lastName || null;
    if (details?.currentBookingInState && !details.pageType) {
      const pageSectionAsParameter = PAGE_SECTION_VARIABLES.MANAGE_BOOKING;
      eventArray.FlightDetail = flightDetails(details.currentBookingInState, pageSectionAsParameter, null, details);
    }
  }

  if (eventName === event.MANAGE_BOOKING_VIEW) {
    eventArray.event = event.MANAGE_BOOKING_VIEW;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    eventArray.pnr = details.currentBookingInState?.recordLocator;
    eventArray.emailId = details.currentBookingInState?.contacts[0]?.value?.emailAddress;
    eventArray.last_name = details.currentBookingInState?.contacts[0]?.value?.name?.last;
    eventArray["Booking id"] = details?.currentBookingInState?.bookingKey;
  }
  if (eventName === event.MANAGE_BOOKING_CHECKIN_VIEW_ERROR) {
    eventArray.event = event.MANAGE_BOOKING_CHECKIN_VIEW_ERROR;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    eventArray.pnr = details.currentBookingInState?.recordLocator;
    eventArray.emailId = details.currentBookingInState?.contacts[0]?.value?.emailAddress;
    eventArray.last_name = details.currentBookingInState?.contacts[0]?.value?.name?.last;
    eventArray["Booking id"] = details?.currentBookingInState?.bookingKey;
    eventArray.error = details.error;
  }
  if (eventName === event.CATEGORY_VIEW) {
    eventArray.event = event.CATEGORY_VIEW;
    eventArray.category_name = details?.category_name;
    eventArray.Page_url = details?.Page_url;
  }
  if (eventName === event.BOOKING_CONTACT_DETAILS_UPDATED) {
    eventArray.event = event.BOOKING_CONTACT_DETAILS_UPDATED;
    eventArray.email = details?.formData?.emailAddress;
    eventArray.phone = details?.formData?.phoneNumber;
    if (details.user) {
      eventArray.customerId = details.user.cusExternalId;
      eventArray.userType = LOGIN_USER;
    } else {
      eventArray.userType = GUEST_USER;
    }
    eventArray.FlightDetail = flightDetails(details.currentBookingInState, "", details?.bookingInRedux, null, details);
  }
  if (eventName === event.ORDER_API_CALLING) {
    eventArray.email = details.email;
    eventArray.lastName = details.lastName;
    eventArray.flowType = details.flowType;
    eventArray.voucherCodes = details?.voucherCodes;
  }
  if (eventName === event.ORDER_API_RESPONDED_SUCCESS) {
    eventArray.email = details.email;
    eventArray.lastName = details.lastName;
    eventArray.recordLocator = details.recordLocator;
    eventArray.channel = details?.channel;
    eventArray.orderId = details.orderId;
    eventArray.flowType = details.flowType;
    eventArray.voucherIds = details.voucherIds;
    eventArray.voucherAmount = details?.voucherAmount;
  }
  if (eventName === event.ORDER_API_RESPONDED_FAILED) {
    eventArray.currentBooking = details.currentBooking;
    eventArray.orderResponse = details.orderResponse;
    eventArray.flowType = details.flowType;
    eventArray.recordLocator = details.recordLocator;
  }

  
  return eventArray;
}

export function basicTrackWithEvents(eventName, details) {
  const eventArray = {};
  eventArray.event = eventName;
  if (details.user) {
    eventArray.customerId = details.user.cusExternalId;
    eventArray.userType = LOGIN_USER;
  } else {
    eventArray.userType = GUEST_USER;
  }
  eventArray.pnr = details.currentBookingInState?.recordLocator;
  eventArray.emailId = details.currentBookingInState?.contacts[0]?.value?.emailAddress;
  eventArray.last_name = details.currentBookingInState?.contacts[0]?.value?.name?.last;
  eventArray["Booking id"] = details?.currentBookingInState?.bookingKey;
  const pageSectionAsParameter = PAGE_SECTION_VARIABLES.CHECK_IN;
  eventArray.FlightDetail = flightDetails(
    details?.currentBookingInState,
    pageSectionAsParameter,
    details?.bookingInRedux,
    details
  );
  return eventArray;
}

export function checkForDuplication(eventName, details) {
  try {
    // check the current payload vs store in eventtrackStack
    const previousEvent = details?.eventTrackStack?.eventStack;

    if (previousEvent && previousEvent[eventName]) {
      const arrivalDiff = moment(previousEvent[eventName].arrivalDateInState).diff(moment(details?.arrivalDateInState));
      const departualDiff = moment(previousEvent[eventName].departureDateInState).diff(
        moment(details?.departureDateInState)
      );
      if (
        previousEvent[eventName].origin === details.origin &&
        previousEvent[eventName].destination === details.destination &&
        previousEvent[eventName].tripType === details.tripType &&
        previousEvent[eventName].passenger?.total === details.passenger?.total &&
        arrivalDiff === 0 &&
        departualDiff === 0
      ) {
        // dont put in list
        return false;
      }
      // put that event into the list
      return true;
    }
    return true;
  } catch (error) {
    console.warn(error);
    return true;
  }
}

export function trackUserActivity({
  page = "",
  section = "",
  eventName = "",
  actionType = "",
  value = "",
  details = {}
}) {
  try {
    
      if (eventName !== event.FLIGHT_LISTING) {
        if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
          GA4Implementation({
            page,
            section,
            eventName,
            actionType,
            value,
            details
          });
        }
       
      }
      if (eventName === event.FLIGHT_LISTING) {
        if (details.origin && checkForDuplication(eventName, details)) {
          const response = restructureObj(eventName, details);
          window.dataLayer.push(response);
          moEngagePush(eventName, response);
          loggingUserActivities(response, details?.flowType);
          if (typeof window !== "undefined" && typeof window.dataLayer !== "undefined") {
            GA4Implementation({
              page,
              section,
              eventName,
              actionType,
              value,
              details
            });
          }
        }
      } else if (eventName === event.FLIGHT_SEARCH_MODIFY) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.FLIGHT_SELECT) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.CATEGORY_VIEW) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.BOOKING_INITIATED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.ADD_PAX_DETAILS) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.FC_GuestDetails_Submitted) {
      
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
       // moEngagePush(eventName, response);

        // adding ga4 ;
        const gaEvent = deepCopy(response);
        gaEvent.event = event.ADD_PAX_DETAILS;
        window.dataLayer.push(gaEvent);
      } else if (eventName === event.ADDONS_SELECTED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
        if (details?.flowType === FLOW_TYPE.CHECK_IN) {
          const gaEvent = deepCopy(response);
          gaEvent.event = event.ADDONS_SELECTED;
          window.dataLayer.push(gaEvent);
        }
      } else if (eventName === event.FLIGHT_SEAT_SELECTED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
        if (details?.flowType === FLOW_TYPE.CHECK_IN) {
          const gaEvent = deepCopy(response);
          gaEvent.event = event.FLIGHT_SEAT_SELECTED;
          window.dataLayer.push(gaEvent);
        }
      } else if (eventName === event.PAYMENT_INITIATED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.PAYMENT_FAILED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType, EventType.FAIL, details?.bookingInState?.recordLocator);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.BOOKING_SUCCESSFUL || eventName === event.MANAGE_BOOKING_ADDONS_ADDED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType, EventType.SUCCESS, response?.PNR);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
        // THE BELOW event is requested to be removed during the flight booking journey.
        if (eventName === event.MANAGE_BOOKING_ADDONS_ADDED) {
          const tempGa4Event = deepCopy(response);
          tempGa4Event.event = event.MANAGE_BOOKING_ADDONS_ADDED_GA4;
          window.dataLayer.push(tempGa4Event);
        }
      } else if (eventName === event.SIGNUP_SUCCESS) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.LOGIN_SUCCESS) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.LOGOUT_SUCCESS) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.CHECKIN_INIT) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        if (response.pageurl === "/check-in-summary") {
          window.dataLayer.push(response);
          moEngagePush(eventName, response);
        }
      } else if (eventName === event.CHECKIN_ACCEPT_NO_DANGEROURS_GOOD) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.CANCELED_BOOKING) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);

        const tempGa4Event = deepCopy(response);
        tempGa4Event.event = event.CANCELED_BOOKING_GA4;
        window.dataLayer.push(tempGa4Event);
      } else if (eventName === event.RETRIVE_BOOKING_WITH_PNR) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);

        if (details?.pageType === "CHECK_IN") {
          const tempGa4Event = deepCopy(response);
          tempGa4Event.event = event.CHECKIN_INIT;
          window.dataLayer.push(tempGa4Event);
        }
      } else if (eventName === event.NEWS_LETTER_SIGNUP) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.CHECKIN_SUCCESSFULL) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType, EventType.SUCCESS);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);

        // ecommmerce array should not be present in the below push
        const tempGa4Event = deepCopy(response);
        if (details?.bookingInRedux.bookingIniatedFrom === bookingIniatedFrom.MANAGE_BOOKING) {
          tempGa4Event.event = event.CHECKIN_SUCCESSFULL_GA4;
          window.dataLayer.push(tempGa4Event);
        }
      } else if (
        eventName === event.MANAGE_BOOKING_VIEW ||
        eventName === event.MANAGE_BOOKING_CHECKIN_CLICKED ||
        eventName === event.MANAGE_BOOKING_CHECKIN_VIEW_POPUP_SUCCESS ||
        eventName === event.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED ||
        eventName === event.BOOKING_CANCEL_INITIATED ||
        eventName === event.BOOKING_CHANGE_INITIATED ||
        eventName === event.MANAGE_BOOKING_ADDONS_CLICKED ||
        eventName === event.MANAGE_BOOKING_ETICKET_CLICKED ||
        eventName === event.MANAGE_BOOKING_BOARDING_PASSED_CLICKED ||
        eventName === event.MANAGE_BOOKING_CALCELLATION_POLICY_CLICKED
      ) {
        const response = basicTrackWithEvents(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        // moEngagePush(eventName, response);
        if (eventName === event.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED) {
          const tempGa4Event = deepCopy(response);
          tempGa4Event.event = event.MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED_GA4;
          window.dataLayer.push(tempGa4Event);
        }
      } else if (eventName === event.MANAGE_BOOKING_CHECKIN_VIEW_ERROR) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
      } else if (eventName === event.FC_CLICKED_ON_SELECT_ADDONS) {
        const response = restructureObj(eventName, details);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
        // also add the same data for ga events :
        const gaEvent = deepCopy(response);
        gaEvent.event = event.ADDONS_SELECTED;
        window.dataLayer.push(gaEvent);

        const tempGa4Event = deepCopy(response);
        tempGa4Event.event = event.ADDONS_SELECTED_GA4;
        window.dataLayer.push(tempGa4Event);
      } else if (eventName === event.BOOKING_CONTACT_DETAILS_UPDATED) {
        const response = restructureObj(eventName, details);
        loggingUserActivities(response, details?.flowType);
        window.dataLayer.push(response);
        moEngagePush(eventName, response);
        const tempGa4Event = deepCopy(response);
        tempGa4Event.event = event.BOOKING_CONTACT_DETAILS_UPDATED_GA4;
        window.dataLayer.push(tempGa4Event);
      } else if (
        eventName === event.FC_AUTO_SEAT_ASSIGN_FOR_CHECKIN ||
        eventName === event.COMPLIMENTARY_MEAL_POPUP_CONFIRM_CLICKED
      ) {
        const response = { name: eventName, data: details };
        loggingUserActivities(response, details?.flowType);
      }else if (eventName === event.FLEXI_BANNER) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.PROMO_NUDGE_CLICKED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.SORT_FILTER_APPLIED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.CHECKIN_FAILED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.PROMO_NUDGE_CLICKED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.SORT_FILTER_APPLIED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.CHECKIN_FAILED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.ADD_PAX_DETAILS) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.BOOKING_SUMMARY) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.FLIGHT_CHECKIN_SEAT_SELECTED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.CHECKIN_ADDONS) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.CHECKIN_PAYMENT_INITIATED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (eventName === event.ORDER_API_CALLING) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (
        eventName === event.ORDER_API_RESPONDED_SUCCESS) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else if (
        eventName === event.ORDER_API_RESPONDED_FAILED) {
        const response = restructureObj(eventName, details);
        moEngagePush(eventName, response);
      } else {
        // window.dataLayer.push({
        //     page,
        //     section,
        //     eventName,
        //     actionType,
        //     value ,
        //     details
        // })
      }
  } catch (error) {
    console.warn(error);
  }
}
